import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "treeDialog" }
const _hoisted_2 = { class: "treeDialogInner" }
const _hoisted_3 = { class: "treeDialogInnerTitle" }
const _hoisted_4 = { class: "treeDialogInnerBox" }
const _hoisted_5 = { class: "treeDialogInnerInput" }
const _hoisted_6 = { class: "treeDialogInnerEl" }
const _hoisted_7 = { class: "simplifiedBtn" }
const _hoisted_8 = { class: "btnBox" }

import { ref, getCurrentInstance, onMounted, watch,nextTick } from 'vue'
  import { ElMessage, ElMessageBox, ElSwitch } from "element-plus";
  import { ElTree } from 'element-plus'
  import {
    Close,
    Search,
  } from "@element-plus/icons-vue";
  // 引入接口
import fileApi from '@/api/sound/fileManage.ts';
  interface Tree {
    [key: string]: any
  }
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'changePath',
  props: {
    selId: String,
  },
  emits: ['closeThis', 'upparentId'],
  setup(__props, { emit: __emit }) {

  const props = __props

  const filterText = ref('')
  const treeRef = ref<InstanceType<typeof ElTree>>()
  
  const defaultProps = {
    children: 'children',
    label: 'label',
  }
  const delTreeThis=ref('')
  const allFolderList = ref([{
    id: '0',
    label: '根目录',
    children: [],
}])
// 获取所有目录
const getAllTree=()=>{
    fileApi.getFolderList().then(res=>{
        console.log(res)
        let resData = JSON.stringify(res.data).replaceAll("filename", "label").replaceAll("fileId", "id")
        allFolderList.value[0].children = (JSON.parse(resData))
        console.log('=========')
        console.log(allFolderList.value)
    })
}
  onMounted(()=>{
    getAllTree()
    // let captionTree=JSON.parse(localStorage.getItem('captionTree')) || []
    // if(captionTree.length>0){
    //   delTreeThis.value=captionTree[captionTree.length - 1].parentId || ''
    //   nextTick(()=>{
    //     treeRef.value?.setCurrentKey(delTreeThis.value)
    //   })
    // }
    
    
  })
  watch(filterText, (val) => {
    treeRef.value!.filter(val)
  })
  
  const filterNode = (value: string, data: Tree) => {
    if (!value) return true
  
    return data.label.includes(value)
  }
  const routStr = ref('根目录')
  const fileId=ref('')
  const handleNodeClick = (data: Tree) => {
    console.log(data)
    fileId.value=data.id
    let list = findParents(allFolderList.value, data)
    routStr.value = ''
    for (let i = list.length - 1; i > -1; i--) {
      console.log(list[i].label)
      routStr.value += ('/' + list[i].label)
    }
    routStr.value += ('/' + data.label)
  
  
  }
  const findParents = (list: any, childNode: any) => {
    const parents = [];
    const findRecursive = (node) => {
      if (node.children && node.children.length > 0) {
        for (let child of node.children) {
          if (child === childNode) {
            parents.push(node);
            return true;
          } else if (findRecursive(child)) {
            parents.push(node);
            return true;
          }
        }
      }
      return false;
    }
    for (let node of list) {
      if (findRecursive(node)) {
        break;
      }
    }
    return parents;
  }
  
  
  //获取当前节点
  const getNode = (data: Tree) => {
    console.log(data)
  }
  const emit = __emit
  // 关闭弹窗
  const closeBox = () => {
    emit('closeThis')
  }
  // 获取prentid
  const handleClose=()=>{
    if(props.selId==fileId.value){
      console.log('选择问价夹为本文件夹')
    }else{
      emit('upparentId',[routStr.value,fileId.value])
    }
    
  
  }
  
return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("span", null, "更改项目目录", -1)),
        _createElementVNode("span", {
          class: "closeBtn",
          onClick: _withModifiers(closeBox, ["stop"])
        }, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Close))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Search))
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterText).value = $event))
          }, null, 512), [
            [_vModelText, filterText.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_scrollbar, { height: "174px" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElTree), {
                ref_key: "treeRef",
                ref: treeRef,
                style: {"max-width":"600px"},
                data: allFolderList.value,
                props: defaultProps,
                "node-key": "id",
                "highlight-current": "",
                "default-expand-all": "",
                "filter-node-method": filterNode,
                onGetCurrentKey: getNode,
                onNodeClick: handleNodeClick
              }, null, 8, ["data"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", {
              class: "btnNo",
              onClick: _withModifiers(closeBox, ["stop"])
            }, "取消"),
            _createElementVNode("span", {
              class: "btnOk",
              onClick: _withModifiers(handleClose, ["stop"])
            }, "确定")
          ])
        ])
      ])
    ])
  ]))
}
}

})